module.exports = __webpack_public_path__ + "static/media/logo-256x256.4801ff95.png";